import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "fs16 mt20 fw600" }, "振り分けフォーム名を変更", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "fs16 mt20 fw600" }, "waaqの利用規約・プライバシーポリシーを表示", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "waaqの利用規約・プライバシーポリシーの表示をオン/オフします。", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_7 = { class: "mt40" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "fs16 mt20 fw600" }, "利用規約を追加", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "URLを設定しておくと、「送信」ボタンの上に利用規約のリンクが表示されます。", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "fw600" }, "利用規約名", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "fw600" }, "利用規約URL", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_13 = { class: "mt40" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "fs16 mt40 fw600" }, "プライバシーポリシーを追加", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "fw600" }, "プライバシーポリシー名", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "fw600" }, "プライバシーポリシーURL", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_18 = { class: "mt40" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "fs16 mt40 fw600" }, "送信ボタンを変更", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "fw600" }, "送信ボタン名", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_22 = { class: "mt20" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "fw600" }, "送信ボタン名の色(000000~ffffff)", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_25 = { class: "mt20" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "fw600" }, "送信ボタンの背景色(000000~ffffff)", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_28 = { key: 1 }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "fs16 mt40 fw600" }, "フォーム自動送信", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "fs14" }, " waaq以外のフォームから自動でフォーム内容を読み取り、公開ページのフォームに埋め、限定公開ページを作成します。 ", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!
  const _component_Switcher = _resolveComponent("Switcher")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      (_ctx.fcm?.aform)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createVNode(_component_TextfieldTag, {
              placeholder: "名前",
              style: {"height":"50px"},
              class: "fl fs14 roundForm mw100 mt20",
              value: _ctx.fcm.aform.title,
              onInputValue: _ctx.inputTitle
            }, null, 8, ["value", "onInputValue"]),
            _hoisted_3
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _hoisted_4,
        _hoisted_5,
        _createVNode(_component_Switcher, {
          value: "type[show_type]",
          name: "waaqの利用規約・プライバシーポリシーを表示",
          checked: _ctx.fcm?.aform ? _ctx.fcm?.aform.show_waaq_tos : _ctx.rcm.room.show_waaq_tos,
          display: "true",
          class: "checkUsingCal fl",
          onSelect: _ctx.changeShowWaaqTos
        }, null, 8, ["checked", "onSelect"]),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _hoisted_9,
        _hoisted_10,
        _createVNode(_component_TextfieldTag, {
          placeholder: "利用規約",
          style: {"height":"50px"},
          class: "fl fs14 roundForm mw100",
          value: _ctx.fcm?.aform ? _ctx.fcm?.aform.terms_of_service_name : _ctx.rcm.room.terms_of_service_name,
          onInputValue: _ctx.inputTosName
        }, null, 8, ["value", "onInputValue"]),
        _hoisted_11,
        _createVNode(_component_TextfieldTag, {
          placeholder: "https://waaq.jp",
          style: {"height":"50px"},
          class: "fl fs14 roundForm mw100",
          value: _ctx.fcm?.aform ? _ctx.fcm?.aform.terms_of_service_url : _ctx.rcm.room_setting.terms_of_service_url,
          onInputValue: _ctx.inputTos
        }, null, 8, ["value", "onInputValue"]),
        _hoisted_12
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _hoisted_15,
        _createVNode(_component_TextfieldTag, {
          placeholder: "プライバシーポリシー名",
          style: {"height":"50px"},
          class: "fl fs14 roundForm mw100",
          value: _ctx.fcm?.aform ? _ctx.fcm?.aform.privacy_policy_name : _ctx.rcm.room.privacy_policy_name,
          onInputValue: _ctx.inputPPName
        }, null, 8, ["value", "onInputValue"]),
        _hoisted_16,
        _createVNode(_component_TextfieldTag, {
          placeholder: "URLを入力",
          style: {"height":"50px"},
          class: "fl fs14 roundForm mw100",
          value: _ctx.fcm?.aform ? _ctx.fcm?.aform.privacy_policy_url : _ctx.rcm.room_setting.privacy_policy_url,
          onInputValue: _ctx.inputPP
        }, null, 8, ["value", "onInputValue"]),
        _hoisted_17
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _hoisted_20,
        _createVNode(_component_TextfieldTag, {
          placeholder: "送信する",
          style: {"height":"50px"},
          class: "fl fs14 roundForm mw100",
          value: _ctx.fcm?.aform ? _ctx.fcm?.aform.form_submit_button_name : _ctx.rcm.room_setting.form_submit_button_name,
          onInputValue: _ctx.inputSubmitButtonName
        }, null, 8, ["value", "onInputValue"]),
        _hoisted_21
      ]),
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _createVNode(_component_TextfieldTag, {
          placeholder: "000000",
          style: {"height":"50px"},
          class: "fl fs14 roundForm mw100",
          value: _ctx.fcm?.aform ? _ctx.fcm?.aform.form_submit_button_text_color : _ctx.rcm?.room.form_submit_button_text_color,
          onInputValue: _ctx.inputButtonTextColor
        }, null, 8, ["value", "onInputValue"]),
        _hoisted_24
      ]),
      _createElementVNode("div", _hoisted_25, [
        _hoisted_26,
        _createVNode(_component_TextfieldTag, {
          placeholder: "000000",
          style: {"height":"50px"},
          class: "fl fs14 roundForm mw100",
          value: _ctx.fcm?.aform ? _ctx.fcm?.aform.form_submit_button_bg_color : _ctx.rcm?.room.form_submit_button_bg_color,
          onInputValue: _ctx.inputButtonBgColor
        }, null, 8, ["value", "onInputValue"]),
        _hoisted_27
      ]),
      (_ctx.fcm?.aform && _ctx.fcm.aform.form_id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _hoisted_29,
            _hoisted_30,
            _createElementVNode("button", {
              type: "submit",
              class: "fl pointer centered circle_button skyblueBg fs14 rad8 mt15 mr20 padw10 fw600",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createFieldConverter && _ctx.createFieldConverter(...args)))
            }, " 質問コンバーターを作成 "),
            _hoisted_31
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}